import type { PromotionUser, UserStore } from '#lib/types'

export const ERROR_SEPARATOR = '_::_'

// Date Time Format
export const DATE_TIME_FORMAT = {
  SHORT_DATE_FORMAT: 'DD-MM-YYYY',
  DAY_MONTH: 'DD/MM',
  DATE_FORMAT: 'DD/MM/YYYY',
  FULL_DATE_FORMAT: 'DD-MM-YYYY HH:mm:ss',
  DATE_FORMAT_MAINTAIN: 'HH:mm DD/MM/YYYY',
  FULL_DATE_FORMAT_A_PM: 'DD/MM/YYYY HH:mmA',
  HOUR_MINUTE: 'HH[h]mm',
  HOUR_MINUTE_DEFAULT: 'HH:mm',
  PUBLISH_TIME: 'HH[h]mm Ngày DD/MM/YYYY',
  PUBLISH_DATE_TIME: 'HH[h]mm | DD/MM/YYYY',
  FULL_DATE_FORMAT_SCHEDULE: 'YYYY-MM-DD HH:mm:ss',
  FULL_DATE_FORMAT_HISTORY: 'HH:mm - DD/MM/YY',
  TIME_DATE_FORMAT_SCHEDULE: 'HH:mm',
  DATE_FORMAT_HOTMATCH: 'YYYY-MM-DD',
}
export const HALF_DAY: number = 43200

export const KEY_ITEM = {
  BANK_TRANCODE: 'bank_trancode',
  TO_BANK_CODE: 'to_bank_code',
  BANK_ACCOUNT_NAME: 'bank_account_name',
  ACCOUNT_NAME: 'accountName',
  METHOD: 'method',
  CODE: 'code',
  ZERO: '0',
}

export const PROMOTION_SLUG_BY_TYPE = {
  COMMISSION: 'hoan-tra-cuoc-1-5',
  WELCOME: 'thuong-100-tien-nap-lan-dau',
  FIRST_50: 'thuong-50-tien-nap-lan-hai',
}

// Ignore Slugs
export const IGNORE_SLUGS = [
  'khuyen-mai',
  'lich-thi-dau',
  'thuong-150-nap-tien-lan-dau',
  'thuong-100-nap-tien-lan-dau',
  'thuong-20-nap-tien-lan-2',
  'hoan-tra-cuoc-15',
  'live-casino',
  'lobby-game',
  'the-thao',
]

// Invoice Status
export const INVOICE_STATUS = {
  CANCEL: 'CANCEL',
  FINISHED: 'FINISHED',
}

// Labels
export const LABEL_ALL_GAME: string = 'Tất cả'

// Day Names
export const DAY_NAMES = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']

// Slugs
export const SLUG_SPORTS = {
  C_SPORTS: 'play-sport-game',
}

export const SLUG_NEWS = {
  PAGE: 'tin-tuc',
  SPORTS: 'soi-keo-bong-da',
}

export const PROMOTION_SLUG = '/khuyen-mai/'

export const SIMPLE_PAGE_SLUG = [
  've-chung-toi',
  'huong-dan-cuoc-bong-da',
  'huong-dan-dang-ky-tai-khoan',
  'huong-dan-nap-rut-tien',
  'khuyen-mai-ca-cuoc',
  'tai-khoan-dung-thu',
  'cau-hoi-thuong-gap',
  'bing88-la-gi',
  'moi-quan-he-cua-8bet-va-bong88-la-gi',
  'cuoc-trung-gian-la-gi',
  'nha-cai-8bet-co-uy-tin-khong',
  'ho-tro-24-7-nhu-the-nao',
  'huong-dan-nap-tien',
  'huong-dan-rut-tien',
  'huong-dan',
  'chinh-sach-bao-mat',
]

export const RESET_PASSWORD_SLUG = 'reset-password'
export const LIST_STORE_EXCLUDE_RESET = ['jackpot']
export const SECONDS_PER_DAY = 60 * 60 * 24
export const COOKIE_MAX_AGE_DAYS = 30

export const DEFAULT_USER: UserStore = {
  id: '',
  email: '',
  avatar: 1,
  birthday: '',
  fullname: '',
  contactName: '',
  gptoken: '',
  phone: '',
  token: '',
  username: '',
  wallet: {
    balance: 0,
    subBalance: 0,
  },
}

export const DEFAULT_PROMOTION_USER: PromotionUser = {
  plan: {},
  today_refund: 0,
  yesterday_refund: 0,
  total_refund: 0,
  total_bet: 0,
  title: '',
  description: '',
  mappingKey: '',
  activedDate: '',
  remainDays: 0,
  turnover: 0,
  rolling: 0,
  calculated_turnover: 0,
  multiplier: 0,
  deposit_amount: 0,
  promotion_amount: 0,
}

// Betting
export const BETTING_STATUS = {
  LOSE: 'lose',
  WIN: 'win',
  WON: 'won',
  DRAW: 'draw',
  RUNNING: 'running',
  RUNING: 'runing',
  OPENED: 'opened',
  WAITING: 'waiting',
  PENDING: 'pending',
  HALF_LOSE: 'half lose',
  HALF_WIN: 'half win',
  HALF_WON: 'half won',
  REJECT: 'reject',
  REFUND: 'refund',
  CANCEL: 'cancel',
  BET: 'bet',
  OPEN: 'open',
  TIP: 'tip',
}

export const HISTORY_BETTING_STATUS: Record<string, string> = {
  WIN: 'WIN,WON,half win,half won,win',
  LOSE: 'LOSE,half lose,lose',
  DRAW: 'DRAW,Draw',
  RUNNING: 'RUNNING,RUNING,PENDING,BET,OPEN,waiting,Runing,Opened,Bet,Open',
  CANCEL: 'reject,refund,cancel,void',
}

export const WALLET = {
  MAIN_WALLET: 'MAIN',
  AGENCY_WALLET: 'SUB',
}

export const DEFAULT_SOCKET_CONFIG = {
  reconnection: true,
  reconnectionAttempts: 3,
  reconnectionDelay: 0,
  timeout: 20000,
  autoConnect: true,
}

export const AFFILIATE_PARAM_KEYS = [
  'a',
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_content',
]

